var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09 7.16c0-1.6 1.31-2.91 2.91-2.91s2.91 1.31 2.91 2.91-1.31 2.91-2.91 2.91a2.92 2.92 0 0 1-2.91-2.91zm1.5 0c0 .78.63 1.41 1.41 1.41.78 0 1.41-.63 1.41-1.41 0-.78-.63-1.41-1.41-1.41-.78 0-1.41.63-1.41 1.41zM3.88 16.84c0-1.6 1.31-2.91 2.91-2.91s2.91 1.31 2.91 2.91-1.31 2.91-2.91 2.91a2.92 2.92 0 0 1-2.91-2.91zm1.5 0c0 .78.63 1.41 1.41 1.41.78 0 1.41-.63 1.41-1.41 0-.78-.64-1.41-1.41-1.41-.78 0-1.41.63-1.41 1.41zM14.3 16.84c0-1.6 1.31-2.91 2.91-2.91s2.91 1.31 2.91 2.91-1.3 2.91-2.91 2.91a2.92 2.92 0 0 1-2.91-2.91zm1.5 0c0 .78.63 1.41 1.41 1.41.78 0 1.41-.63 1.41-1.41 0-.78-.63-1.41-1.41-1.41-.78 0-1.41.63-1.41 1.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMore2);
export default __webpack_public_path__ + "static/media/vuesax-outline-more-2.1f3cf430855ca51e0dcec20f333c2e94.svg";
export { ForwardRef as ReactComponent };